import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import { WeightUnit } from '@/types';
import List from '@/assets/common/List/List.vue';
import store from '@/assets/common/store/store';

@Component({
    components: {
        List
    }
})
export default class HarvestShipping extends Vue {
    private list: any | null = null
    private title = '収穫・出荷'
    private isLoading = false
    private menuId = ''
    private menuTitle? = '計測タイミング'
    private menu = [
        {
            id: 'measurement_timings',
            name: '計測タイミング'
        },
        {
            id: 'quality_standards',
            name: '品質・規格'
        },
        {
            id: 'weight_units',
            name: '単位'
        }
    ]
    private items = []
    private withHidden = false
    private isEdit = false
    private newName = ''
    private newWeightPerUnit?: number | null = null
    private itemId?: string | null = ''
    private isAdd = false
    private isWeightUnits = false
    private baseUrl = ''

    @Prop({
        default: () => 'measurement_timings'
    })
    private id!: string

    @Watch('id')
    private onChangeId() {
        this.withHidden = false
        this.isWeightUnits = false
        this.isAdd = false
        this.isEdit = false
        this.newName = ''
        this.newWeightPerUnit = null
    }

    private created(){
        this.isLoading = true
        if(this.id) this.menuId = this.id
        this.$apiClient.getUserProfile().then(ret => {
            if(ret.role.indexOf('ADMIN') != -1) {
                this.menu.push(
                    {
                        id: 'shipping_destinations',
                        name: '出荷先'
                    })
            }
        }).finally(() => {
            this.list = List
            this.isLoading = false
        })
    }

    private init() {
        this.isAdd = false
        this.isEdit = false
        this.newName = ''
        this.newWeightPerUnit = null
    }

    private setMenu(item: string) {
        this.$router.push( '/master/harvest_shipping/' + this.menuId, () => {return})
        if(store.getters.isInputChanged==false){
        this.menuId = item
        this.menuTitle = this.menu.find(elm => elm.id == item)?.name
        this.getItems(this.withHidden)
        }
    }

    private getItems(withHidden: boolean) {
        let url = '/' + this.menuId
        if(this.menuId == 'shipping_destinations') url = '/admin/' + this.menuId
        this.baseUrl = url
        if(withHidden) url += '?with_hidden=' + withHidden
        this.$apiClient.doRequest('get', url).then(ret => {
            this.items = ret[this.menuId]
            this.isWeightUnits = (this.menuTitle == '単位')
        }).catch(error => {
            this.items = []
        })
    }

    private addItems() {
        this.isAdd = true
    }

    private edit(item: WeightUnit) {
        this.itemId = item.id
        this.isEdit = true
        this.newName = item.name
        this.newWeightPerUnit = item.weight_per_unit
    }

    private cancelEdit() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        this.init()
    }

    private onChangeWithHidden() {
        this.withHidden = !this.withHidden
        this.getItems(this.withHidden)
    }

    private validate() {
        const errmsg: string[] = []

        // 名前
        if(!this.newName){
            errmsg.push(`${this.menuTitle}名を入力してください。`)
        }

        // 名前の長さ
        if(this.newName.length > 255){
            errmsg.push(`255文字以内で名前を入力してください（現在は${this.newName.length}文字）`)
        }

        // 数量
        if(this.isWeightUnits && this.newWeightPerUnit){
            const isMinus: boolean = /-/.test(this.newWeightPerUnit.toString())
            const integer: string = this.newWeightPerUnit.toString().split('.')[0]
            const decimal: string = this.newWeightPerUnit.toString().split('.')[1]
            if(isMinus || this.newWeightPerUnit == 0 || integer.length > 7 || decimal && decimal.length > 3){
                errmsg.push('重量は0より大きい整数部7桁小数部3桁までの数値を入力してください。')
            }
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        return true
    }

    private doAdd() {
        if(!this.validate()) {
            return
        }
        this.isLoading = true
        const params: WeightUnit = {
            name: this.newName,
            is_hidden: false
        }
        if(this.isWeightUnits) params.weight_per_unit = this.newWeightPerUnit
        const url = this.baseUrl
        this.save('post', url, params)
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }

    private doUpdate(item: WeightUnit) {
        if(!item && !this.validate()) {
            return
        }
        const result = window.confirm('内容を上書きして保存します。よろしいですか。')
        this.isLoading = true
        if (!result) {
            this.isLoading = false
            return false;
        }
        const params: WeightUnit = {
            name: this.newName,
            is_hidden: item.is_hidden
        }
        if(this.isWeightUnits) {
            params.weight_per_unit = this.newWeightPerUnit
        }
        const url = `${this.baseUrl}/${item.id}`
        this.save('put', url, params)
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }

    private updateIsHidden(item: WeightUnit, isHidden: boolean) {
        let confirmMessage = `${item.name}を表示状態に戻します。よろしいですか？`
        if (isHidden) {
            confirmMessage = `${item.name}を非表示にします。よろしいですか？`
        }
        const result = window.confirm(confirmMessage)
        this.isLoading = true
        if (!result) {
            this.isLoading = false
            return false;
        }
        const params: WeightUnit = {
            name: item.name,
            is_hidden: isHidden
        }
        if(this.isWeightUnits) {
            params.weight_per_unit = item.weight_per_unit
        }
        const url = `${this.baseUrl}/${item.id}`
        this.save('put', url, params)
    }

    private save(method: 'post' | 'put', url: string, params: WeightUnit) {
        let toastedMessage = ''
        let toastedErrorMessage = ''
        switch (method) {
            case 'post':
                toastedMessage = '追加しました。'
                toastedErrorMessage = '追加に失敗しました。'
                break
            case 'put':
                toastedMessage = '変更しました。'
                toastedErrorMessage = '変更に失敗しました。'
                break
        }
        this.$apiClient.doRequest(method, url, params).then(() => {
            this.$toasted.success(toastedMessage)
            this.getItems(this.withHidden)
        }).catch(() => {
            this.$toasted.error(toastedErrorMessage)
        }).finally(() => {
            this.isLoading = false
            this.init()
        })

    }

    @Emit('inputChanged')
    private inputChanged(){
     if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
    } 
   }
}